export default "__VITE_ASSET__BA$BwUwn__"